export enum ClipId {
  LeftClip = 0,
  RightClip = 1,
  BottomClip = 2,
  TopClip = 3,
  FrontClip = 4,
  BackClip = 5
}

export type ClipDirection =
  | 'left'
  | 'right'
  | 'top'
  | 'bottom'
  | 'front'
  | 'back';

export const ClipIdForDirection: Record<ClipDirection, ClipId> = {
  left: ClipId.LeftClip,
  right: ClipId.RightClip,
  bottom: ClipId.BottomClip,
  top: ClipId.TopClip,
  front: ClipId.FrontClip,
  back: ClipId.BackClip
};

export const directionForClipId: Record<ClipId, ClipDirection> = {
  0: 'left',
  1: 'right',
  2: 'bottom',
  3: 'top',
  4: 'front',
  5: 'back'
};

export interface ClippingPlane {
  progress: number;
  fadeDistance: number;
  enabled: boolean;
  fade: boolean;
  clipId: ClipId;
}

export interface ClipBoundaries {
  xmin: number;
  xmax: number;
  ymin: number;
  ymax: number;
  zmin: number;
  zmax: number;
}

export interface ClippingPlanes {
  clips: Record<ClipDirection, ClippingPlane>;
  boundary?: ClipBoundaries;
  enabled: boolean;
}
